import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

type ModalContent = {
  header: string;
  body: string;
  cancel: string;
  leave?: string;
  save: string;
};

type Props = {
  onClose: () => void;
  onLeave?: () => void;
  onSave: () => void;
  isModalOpen: boolean;
  modalContent: ModalContent;
};

export const LostProgressModal = ({
  onClose,
  onLeave,
  onSave,
  isModalOpen,
  modalContent,
}: Props) => {
  return (
    <Modal
      id="unsavedChangesModal"
      isModalOpen={isModalOpen}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>{modalContent.header}</ModalHeader>

      <ModalBody>{modalContent.body}</ModalBody>

      <ModalFooter>
        {modalContent.leave && onLeave && (
          <Button onClick={onLeave} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY}>
            {modalContent.leave}
          </Button>
        )}

        <Button onClick={onSave} size={BUTTON_SIZES.LARGE}>
          {modalContent.save}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
